/* @ngInject */
const local = () => {
  const self = {}

  return self
}

export default local



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/contact/services/local.service.js